<div>
  @switch (action) {
    @case ('setup') {
      <div>
        <app-multi-factor-setup></app-multi-factor-setup>
      </div>
    }
    @default {
      <div>
        <app-multi-factor-process></app-multi-factor-process>
      </div>
    }
  }
</div>